import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { PROCESS } from "@/data/content";
import { Reveal, LineReveal } from "./motion/Reveal";

export const Process = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 70%", "end 80%"] });
  const height = useTransform(scrollYProgress, [0, 1], ["0%", "100%"]);

  return (
    <section id="process" data-testid="process-section" className="section-y bg-ivory">
      <div className="container-x grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-32">
            <Reveal><p className="eyebrow mb-6">Process</p></Reveal>
            <LineReveal inView as="h2" lines={["A considered path", <>from idea to <span className="italic text-sage">launch.</span></>]} className="h2" />
            <Reveal delay={0.2} className="body-lg mt-8 space-y-5">
              <p>Every project is different, so we do not promise a fixed number of days. Instead, we work efficiently and communicate clearly, delivering as quickly as practical while protecting the quality of the final website.</p>
              <p className="text-sm text-taupe">Timelines are shaped by scope, functionality, content readiness and the level of customization involved.</p>
            </Reveal>
          </div>
        </div>

        <div ref={ref} className="lg:col-span-6 lg:col-start-7 relative">
          <div className="absolute left-[19px] top-0 bottom-0 w-px bg-taupe-line" aria-hidden />
          <motion.div style={{ height }} className="absolute left-[19px] top-0 w-px bg-sage origin-top" aria-hidden />
          <ol className="space-y-2">
            {PROCESS.map((s, i) => (
              <Reveal key={s.n} delay={0.05} data-testid={`process-step-${i + 1}`} className="group relative pl-16 py-7 border-b border-taupe-line/70 last:border-0">
                <span className="absolute left-0 top-8 h-10 w-10 rounded-full bg-ivory border border-taupe-line flex items-center justify-center font-mono text-[10px] text-sage group-hover:bg-charcoal group-hover:text-ivory group-hover:border-charcoal transition-colors duration-500">{s.n}</span>
                <h3 className="font-serif text-3xl lg:text-4xl font-light text-charcoal leading-none transition-transform duration-500 ease-out group-hover:translate-x-2">{s.title}</h3>
                <p className="text-sm sm:text-[15px] text-ink/70 font-light leading-relaxed mt-3 max-w-md">{s.desc}</p>
              </Reveal>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
};
